module.exports = __webpack_public_path__ + "static/media/au-sa.e47f3185.svg";